import {Box, Center, Flex, Image, Text} from "@mantine/core";
import {Carousel} from "@mantine/carousel";
import { useRef } from '@wordpress/element';
import Autoplay from 'embla-carousel-autoplay';
import CategoryPlaceholderImage from '../../../../../assets/images/category_placeholder.png';

const _CategoryTrendingItems = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                // bg={component?.customize_styles?.text_decoration?.background_color}
                fz={component?.customize_styles?.text_decoration?.font_size}
                fw={component?.customize_styles?.text_decoration?.font_weight}
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
            >
                {component?.customize_properties?.label}
            </Text>
            <Carousel
                slideSize={100}
                loop
                align="start"
                withControls={false}
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}
                styles={{
                    viewport: {
                        overflow: "visible",
                        overflowX: "clip",
                    },
                    indicators: {
                        position: "absolute",
                        top: "-22%",
                        right: "-78%",
                    },
                    indicator: {
                        backgroundColor: 'var(--mantine-color-gray-3)',
                        width: 10,
                        height: 10,
                        borderRadius: "100%",
                        '&[data-active="true"]': {
                            width: 20,
                            height: 20,
                            backgroundColor: 'var(--mantine-color-orange-5)',
                        },

                    }

                }}
            >
                {
                    component?.items?.map((item, index) => (
                        <Carousel.Slide key={item.id}>
                            <Box
                                // h={88}
                                w={103}
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                // pos="relative"
                                style={{
                                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    display: "flex",
                                    alignItems: "flex-end",
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                }}
                            >

                                <Flex
                                    align="center"
                                    justify="space-between"
                                    direction="column"
                                    w="100%"
                                    h="100%"
                                >
                                    <Center mt={-20} >
                                        <Image
                                            src={item.image_url}
                                            fallbackSrc={CategoryPlaceholderImage}
                                            alt="Product"
                                            style={{ width: "100%", height: "100%" }}
                                            radius={component?.customize_styles?.image_decoration?.radius}
                                            // w={component?.customize_styles?.image_decoration?.width * 1000}
                                            // h={component?.customize_styles?.image_decoration?.height * 1000}
                                            w={component?.customize_styles?.image_decoration?.width}
                                            h={component?.customize_styles?.image_decoration?.height}
                                        />
                                    </Center>
                                    <Text
                                        lineClamp={1}
                                        translate="yes"
                                        c={component?.customize_styles?.name_text_decoration?.color}
                                        fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                        fz={component?.customize_styles?.name_text_decoration?.font_size}
                                        fs={component?.customize_styles?.name_text_decoration?.font_style}
                                    >
                                        {item.name}
                                    </Text>
                                </Flex>
                            </Box>
                        </Carousel.Slide>
                    ))
                }
            </Carousel>
        </Box>
    )
}
export default _CategoryTrendingItems;